import React from "react";
import { withStyles } from "@mui/styles";
import { Dialog } from "@mui/material";
import QrReader from "react-web-qr-reader";
const styles = (theme) => ({
  root: {
    margin: 0,
  //  padding: theme.spacing(2),
   // color: color.PRIMARY,
  },
  clearIcon: {
    float: "right",
    cursor: "pointer",
    //marginRight: "10px",
    display: "flex",
    justifyContent: "center",
    zIndex: 2,
    position:"absolute",
    right: 5,
    margin: 8,
    borderRadius: 4,
    fontSize: 10,
    width: 20,
    height: 20,
    color: "#FFF",
    alignItems: "center",
    background: "#212529",

    '& + div > section > section div':{
      //backgroundColor:"red"
      position:"absolute !important",
      display:"block !important",
      top:"10px !important",
      boxShadow:"none !important",
      background:"none !important",
      border:"none !important",
      top:"20px !important",
      width:"70% !important",
      height: "70% !important",
      margin: "1.75rem 2.25rem",
      background: "linear-gradient(to right, #F64E60 4px, transparent 4px) 0 0, linear-gradient(to right, #F64E60 4px, transparent 4px) 0 100%, linear-gradient(to left, #F64E60 4px, transparent 4px) 100% 0, linear-gradient(to left, #F64E60 4px, transparent 4px) 100% 100%, linear-gradient(to bottom,#F64E60 4px, transparent 4px) 0 0, linear-gradient(to bottom, #F64E60 4px, transparent 4px) 100% 0, linear-gradient(to top, #F64E60 4px, transparent 4px) 0 100%, linear-gradient(to top, #F64E60 4px, transparent 4px) 100% 100%",
      backgroundRepeat: "no-repeat",
      backgroundSize: "20px 20px",
    }
    // right:0,
    // padding:10,
    // zIndex:1,
    // fontWeight:"bolder",
    // position:"absolute",
    // color: color.WHITE,
  },
  closeButton: {
    position: "absolute",
    // right: theme.spacing(1),
    // top: theme.spacing(1),
    // color: theme.palette.grey[500],
  },
 
});


class QrScanner extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const previewStyle = {
      height: 250,
      width: 230,
      display: "flex",
      justifyContent: "center",
    };
    const camStyle = {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
     // marginTop: "-23px",
      position: "relative",
    };
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          // onClose={this.props.handleClose}
          aria-labelledby="customized-dialog-title"
          hideBackdrop={true}
          className={this.props.className}
          open={this.props.open}
        >
          <div className={classes.clearIcon} onClick={this.props.handleClose}>
            &#x2715;
          </div>
        
          <div style={camStyle}>
            <QrReader
              delay={300}
              facingMode={"user"}
              style={previewStyle}
              onError={this.props.handleError}
              onScan={this.props.handleScan}
              //   style={{ height: 100}}
            />
          </div>
          {/* </DialogContent> */}
          {/* <DialogActions>
              <Button autoFocus onClick={this.props.handleClose} color="primary">
                Save changes
              </Button>
            </DialogActions> */}
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(QrScanner);
// export default function CustomizedDialogs() {
//   const [open, setOpen] = React.useState(false);

//   const handleClickOpen = () => {
//     setOpen(true);
//   };
//   const handleClose = () => {
//     setOpen(false);
//   };

//   return (
//     <div>
//       <Button variant="outlined" color="primary" onClick={handleClickOpen}>
//         Open dialog
//       </Button>
//       <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
//         <DialogTitle id="customized-dialog-title" onClose={handleClose}>
//           Modal title
//         </DialogTitle>
//         <DialogContent dividers>
//         <QrReader
//           delay={300}
//           onError={this.handleError}
//           onScan={this.handleScan}
//           style={{ width: '100%' }}
//         />
//         </DialogContent>
//         <DialogActions>
//           <Button autoFocus onClick={handleClose} color="primary">
//             Save changes
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }
